import { render, staticRenderFns } from "./backgound.vue?vue&type=template&id=38cf1630&scoped=true"
import script from "./backgound.vue?vue&type=script&lang=js"
export * from "./backgound.vue?vue&type=script&lang=js"
import style0 from "./backgound.vue?vue&type=style&index=0&id=38cf1630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cf1630",
  null
  
)

export default component.exports